<div class="content-wrapper" *ngIf="user.role === 'admin' || user.role === 'manager' || user.role === 'account'">
  <section class="content" style="padding-top: 40px;">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-3">
          <div class="info-box">
            <span class="info-box-icon bg-info elevation-1"><i class="fa fa-building"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">All Inventory</span>
              <span class="info-box-number">
                {{allStats?.all}}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-danger elevation-1"><i class="fa fa-th-list"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Available</span>
              <span class="info-box-number">{{allStats?.available}}</span>
            </div>
          </div>
        </div>

        <div class="clearfix hidden-md-up"></div>

        <div class="col-12 col-sm-6 col-md-3">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-success elevation-1"><i class="fas fa-shopping-cart"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Sold</span>
              <span class="info-box-number">{{allStats?.sold}}</span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-users"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Customers</span>
              <span class="info-box-number">{{allStats?.customers}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title">Monthly Recap Report</h5>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-sm-3 col-6">
                  <div class="description-block border-right">
                    <span class="description-percentage text-success"><i class="fas fa-caret-up"></i> 17%</span>
                    <h5 class="description-header">$35,210.43</h5>
                    <span class="description-text">TOTAL REVENUE</span>
                  </div>
                </div>
                <div class="col-sm-3 col-6">
                  <div class="description-block border-right">
                    <span class="description-percentage text-warning"><i class="fas fa-caret-left"></i> 0%</span>
                    <h5 class="description-header">$10,390.90</h5>
                    <span class="description-text">TOTAL COST</span>
                  </div>
                </div>
                <div class="col-sm-3 col-6">
                  <div class="description-block border-right">
                    <span class="description-percentage text-success"><i class="fas fa-caret-up"></i> 20%</span>
                    <h5 class="description-header">$24,813.53</h5>
                    <span class="description-text">TOTAL PROFIT</span>
                  </div>
                </div>
                <div class="col-sm-3 col-6">
                  <div class="description-block">
                    <span class="description-percentage text-danger"><i class="fas fa-caret-down"></i> 18%</span>
                    <h5 class="description-header">1200</h5>
                    <span class="description-text">GOAL COMPLETIONS</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row"  *ngIf="!isloading">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header border-transparent">
              <h3 class="card-title">Due Payments
                <span *ngIf="duePayments">
                  {{duePayments.length}}
                </span>
              </h3>
            </div>
            <div class="card-body table-responsive p-0" style="height: 410px;">
              <table class="table table-head-fixed text-nowrap">
                <thead>
                <tr>
                  <th>Property ID</th>
                  <th>Customer Name</th>
                  <th>Contact Number</th>
                  <th>Amount</th>
                  <th>Payment PLAN</th>
                  <th>Payment Date</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let customer of duePayments">
                  <td><a href="javascript:void(0)">{{customer.pid}}</a></td>
                  <td>{{customer.name}}</td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">{{customer.contact_1}}</div>
                  </td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">
                      {{customer.amount| currency:'INR':'symbol'}}
                    </div>
                  </td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">
                      {{customer.type |uppercase}}
                    </div>
                  </td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">
                      {{customer.payment_date | date:'fullDate'}}
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="card">
            <div class="card-header border-transparent">
              <h3 class="card-title">Latest Sales</h3>
            </div>
            <div class="card-body table-responsive p-0" style="height: 400px; overflow: auto;">
              <table class="table  table-head-fixed text-nowrap">
                <thead>
                <tr>
                  <th>Property ID</th>
                  <th>Customer Name</th>
                  <th>Property Cost</th>
                  <th>Sales Officer</th>
                  <th>Sales date</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let customer of customers">
                  <td><a href="javascript:void(0)">{{customer.pid}}</a></td>
                  <td>{{customer.name}}</td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">
                      {{customer.property_cost| currency:'INR':'symbol'}}
                    </div>
                  </td>
                  <td>{{customer.sale_person?.name}}</td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">
                      {{customer.createdAt| date:'longDate'}}
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Recent Payment Received</h3>
            </div>
            <div class="card-body p-0" style="height: 400px; overflow: auto;">
              <ul class="products-list product-list-in-card pl-2 pr-2">
                <li class="item" *ngFor="let payment of payments">
                  <div class="product-info">
                    <a href="javascript:void(0)" class="product-title">{{payment.customer.pid}}
                      <span class="badge badge-warning float-right">{{payment.amount | currency:'INR'}}</span></a>
                    <span class="product-description">
                      {{payment.customer.name}}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="isloading">
        <div class="col-12">
          <p class="text-center">loading ...</p>
        </div>
      </div>
    </div>
  </section>
</div>




<div class="content-wrapper" *ngIf="user.role === 'sales'">
  <section class="content" style="padding-top: 40px;">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-danger elevation-1"><i class="fa fa-th-list"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Target</span>
              <span class="info-box-number">30</span>
            </div>
          </div>
        </div>

        <div class="clearfix hidden-md-up"></div>

        <div class="col-12 col-sm-6 col-md-4">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-success elevation-1"><i class="fas fa-user"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Customers</span>
              <span class="info-box-number">{{allStats?.ctx}}</span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-users"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Leads</span>
              <span class="info-box-number">{{allStats?.leads}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row"  *ngIf="!isloading">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header border-transparent">
              <h3 class="card-title">Due Payments
                <span *ngIf="duePayments">
                  {{duePayments.length}}
                </span>
              </h3>
            </div>
            <div class="card-body table-responsive p-0" style="max-height: 410px;">
              <table class="table table-head-fixed text-nowrap">
                <thead>
                <tr>
                  <th>Property ID</th>
                  <th>Customer Name</th>
                  <th>Contact Number</th>
                  <th>Amount</th>
                  <th>Payment PLAN</th>
                  <th>Payment Date</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let customer of duePayments">
                  <td><a href="javascript:void(0)">{{customer.pid}}</a></td>
                  <td>{{customer.name}}</td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">{{customer.contact_1}}</div>
                  </td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">
                      {{customer.amount| currency:'INR':'symbol'}}
                    </div>
                  </td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">
                      {{customer.type |uppercase}}
                    </div>
                  </td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">
                      {{customer.payment_date | date:'fullDate'}}
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="card">
            <div class="card-header border-transparent">
              <h3 class="card-title">My Sales</h3>
            </div>
            <div class="card-body table-responsive p-0" style="max-height: 400px; overflow: auto;">
              <table class="table  table-head-fixed text-nowrap">
                <thead>
                <tr>
                  <th>Property ID</th>
                  <th>Customer Name</th>
                  <th>Property Cost</th>
                  <th>Sales date</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let customer of customers">
                  <td><a href="javascript:void(0)">{{customer.pid}}</a></td>
                  <td>{{customer.name}}</td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">
                      {{customer.property_cost| currency:'INR':'symbol'}}
                    </div>
                  </td>
                  <td>
                    <div class="sparkbar" data-color="#00a65a" data-height="20">
                      {{customer.createdAt| date:'longDate'}}
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="isloading">
        <div class="col-12">
          <p class="text-center">loading ...</p>
        </div>
      </div>
    </div>
  </section>
</div>

